export default __webpack_public_path__ + "images/BY.3c50c9f.png";